module.exports = __webpack_public_path__ + "img/TextWeVent_thumbnail_beta.d8b04dc3.svg";